@if (loading()) {
  <div class="flex items-center gap-2 text-gray-500 text-sm py-4">
    <i class="pi pi-spin pi-spinner"></i>
    <span>Loading profile…</span>
  </div>
} @else if (error()) {
  <div class="text-red-600 text-sm py-4" role="alert">
    {{ error() }}
  </div>
} @else if (!sectionsWithDisplayValues().length) {
  <p class="text-gray-500 text-sm py-4">Select a client to view their profile.</p>
} @else {
  <div class="client-profile">
    @for (section of sectionsWithDisplayValues(); track section.id ?? section.title) {
      <section
        class="profile-section border border-gray-200 rounded-lg bg-white overflow-hidden"
        [attr.aria-labelledby]="'profile-section-' + (section.id ?? section.title)"
      >
        <h2
          [id]="'profile-section-' + (section.id ?? section.title)"
          class="text-sm font-semibold text-gray-700 bg-gray-50 px-4 py-2 border-b border-gray-200 flex items-center justify-between gap-2"
        >
          <span>{{ section.title }}</span>
          @if (section.hasEditableItems) {
            <p-button
              icon="pi pi-pencil"
              ariaLabel="Edit section"
              variant="text"
              [rounded]="true"
              size="small"
              (onClick)="editService.openSectionEdit(section)"
            ></p-button>
          }
        </h2>
        <dl class="px-4 py-3 flex flex-col gap-3">
          @for (item of section.items; track item.key ?? item.label) {
            <div class="flex flex-col gap-1">
              <dt class="text-gray-500 font-bold text-xs uppercase tracking-wide">
                {{ item.label }}
              </dt>
              <dd class="text-gray-800 text-sm min-h-[2rem] flex items-center gap-2 flex-wrap">
                <span class="text-gray-700">
                  {{ item.displayValue ?? '—' }}
                </span>
                @if (item.displayValue && isPhoneKey(item.key)) {
                  <a
                    [href]="'tel:' + normalizePhone(item.displayValue + '')"
                    class="text-gray-400 hover:text-indigo-600 transition-colors"
                    [attr.aria-label]="'Call ' + item.displayValue"
                    title="Call"
                    (click)="$event.stopPropagation(); $any($event.target).closest('[class*=__action]') && $any($event.currentTarget).removeAttribute('open')"
                  >
                    <i class="pi pi-phone text-xs"></i>
                  </a>
                }
                @if (item.displayValue && isEmailKey(item.key)) {
                  <a
                    [href]="'mailto:' + item.displayValue"
                    class="text-gray-400 hover:text-indigo-600 transition-colors"
                    [attr.aria-label]="'Email ' + item.displayValue"
                    title="Email"
                    (click)="$event.stopPropagation(); $any($event.target).closest('[class*=__action]') && $any($event.currentTarget).removeAttribute('open')"
                  >
                    <i class="pi pi-envelope text-xs"></i>
                  </a>
                }
                <details class="bai-profile-kebab" (click)="$event.stopPropagation(); $any($event.target).closest('[class*=__action]') && $any($event.currentTarget).removeAttribute('open')">
                  <summary class="bai-profile-kebab__btn" aria-label="Profile item options">
                    <i class="pi pi-bars" aria-hidden="true"></i>
                  </summary>
                  <button
                    type="button"
                    class="bai-profile-kebab__action"
                    (click)="addProfileItemToCopilot(section.title, item)"
                  >
                    Add to Copilot
                  </button>
                </details>
              </dd>
            </div>
          }
        </dl>
      </section>
    }
  </div>
}
